/* eslint eqeqeq: "off" */
import React, { useState, useEffect } from "react";
import {
  Col,
  Image,
  Modal,
  Input,
  Row,
  Typography,
  Spin,
  DatePicker,
} from "antd";
import { MetaTags } from "react-meta-tags";
// import { CommentOutlined, CloseOutlined } from "@ant-design/icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import "./index.css";
import Cabs from "../../assets/images/cab-outstation.png";
// import Cabs from "../../assets/images/cabs/car-banner.jpg";
// import { useDispatch, useSelector } from "react-redux";
import { cabTabs, localTripTabsDetails, outStationTrips } from "./data";
import { loadCabDetailsList } from "../../store/activities-list/actions";
import { useDispatch, useSelector } from "react-redux";
import { FaCar, FaUser, FaMobile } from "react-icons/fa6";
import { emailIsValid, phoneIsValid } from "../../helpers/validations";
import { MailFilled } from "@ant-design/icons";
// import { toast } from "react-toastify";
import { toast } from "react-hot-toast";
import api from "../../helpers";
import moment from "moment"
// import addNotification from "react-push-notification";

const CabsDetails = () => {
  const media = useMedia();
  const dispatch = useDispatch();

  const [cabTabsList, setCabTabsList] = useState("Out Station");
  const [isHovered, setIsHovered] = useState(false);
  const [isFareHovered, setIsFareHovered] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState("");
  const [fareDetails, setFareDetails] = useState("");
  const [outStationTabs, setOutStationTabs] = useState(
    "Out Station - Day Basis"
  );
  const [localTripTabs, setLocalTripTabs] = useState("10 Hrs");
  const [enquireDetails, setEnquireDetails] = useState("");
  const [enquireModal, setEnquireModal] = useState(false);

  //store integrations
  useEffect(() => {
    dispatch(loadCabDetailsList("?type=OutStationDay"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const { destination_list = [] } = useSelector((state) => state.Dashboard);
  const { cab_details_list = [] } = useSelector((state) => state.Activities);

  //enquire now details
  const [vehicleName, setVehicleName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMail, setCustomerMail] = useState("");
  const [travelDate, setTravelDate] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
  const [adultData, setAdultData] = useState("");
  const [childData, setChildData] = useState("");
  const [enquireLoading, setEnquireLoading] = useState(false);
  const [customerMobileValidations, setCustomerMobileValidations] =
    useState(false);
  const [customerEmailValidations, setCustomerEmailValidations] =
    useState(false);

  const [cabsLoading, setCabsLoading] = useState(false);
  const [enquireNowButtonDisabled, setEnquireNowButtonDisabled] =
    useState(false);
  const [enquireValidations, setEnquireValidations] = useState(false);

  //mobile and mail validations
  const validationEnquireChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMobile(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-enquire-panel").style.display = "block";
      mainInput.value = current_value;
      setCustomerMobileValidations(true);
    } else {
      document.getElementById("error-enquire-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setCustomerMobileValidations(false);
    }
  };

  //Email validation changes
  const validationEnquireEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-enquire-email-panel").style.display =
        "block";
      mainInput.value = current_value;
      setCustomerEmailValidations(true);
    } else {
      document.getElementById("error-enquire-email-panel").style.display =
        "none";
      setCustomerEmailValidations(false);
    }
  };

  //api reponse list
  const cabDetailsTable =
    cab_details_list &&
    cab_details_list.queryResult &&
    cab_details_list.queryResult.length > 0
      ? cab_details_list.queryResult.map((data) => {
          return {
            amount: data.amount,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            createdByName: data.createdByName,
            driverLabourCost: data.driverLabourCost,
            fareAfterFreeKms: data.fareAfterFreeKms,
            fareAfterFreeHrs: data.fareAfterFreeHrs,
            freeKmsPerDay: data.freeKmsPerDay,
            rentPerDay: data.rentPerDay,
            imageUrl: data.images.length > 0 ? data.images[0] : "",
            farePerKms: data.farePerKms,
            hours: data.hours,
            seats: data.seats,
            status: data.status,
            taxPercentage: data.taxPercentage,
            totalAmount: data.totalAmount,
            type: data.type,
            vehicleName: data.vehicleName,
            vehicleType: data.vehicleType,
            vehicleData: data.vehicleData,
            minimumKmPerDay: data.minimumKmPerDay,
            vehicleId: data.vehicleId,
            _id: data._id,
          };
        })
      : [];

  const taxPercentage =
    fareDetails !== undefined && fareDetails.amount && fareDetails.taxPercentage
      ? parseFloat((fareDetails.amount * fareDetails.taxPercentage) / 100)
      : 0;
  const totalAmount =
    fareDetails !== undefined && parseFloat(fareDetails.amount + taxPercentage);

  // const buttonClick = () => {
  //   addNotification({
  //     title: "Cab Enquiry",
  //     subtitle: "Thank you for your enquiry about our product",
  //     // message: "This is a very long message",
  //     // sty
  //     theme: "red",
  //     duration: 3000,
  //     native: false,
  //   });
  // };
  const enquireNowDetails = () => {
    // setPackageTabDetails("Calculate Price");
    if (customerMobile !== "" && customerName !== "") {
      setEnquireNowButtonDisabled(true);
      setTimeout(() => {
        setEnquireNowButtonDisabled(false);
      }, 3000);
      const cabEnquiries = {
        vehicleId: enquireDetails.vehicleId, // mandatory
        tariffId: enquireDetails._id, // mandatory
        userName: customerName, // mandatory
        mobileNo: customerMobile, // mandatory
        emailId: customerMail ? customerMail : "",
        pickupLocation: pickupLocation ? pickupLocation : "",
        dateOfTravel: travelDate ? moment(travelDate).format("YYYY-MM-DD") : "",
        // remarks: "Some Testing remarks",
        travellers: {
          adult: adultData,
          child: childData,
        },
      };
      const cabEnquiriesObj = Object.keys(cabEnquiries).forEach(
        (k) =>
          (cabEnquiries[k] == "" || cabEnquiries[k] == undefined) &&
          delete cabEnquiries[k]
      );

      console.log(cabEnquiriesObj, "cabEnquiriesObj");
      api
        .post("/cab-tariff-enquiry/create", cabEnquiries)
        .then((res) => {
          setEnquireLoading(true);
          // buttonClick();
          toast.success("Thank you for your enquiry about our product");
          setTimeout(() => {
            setEnquireLoading(false);
            setEnquireModal(false);
            setEnquireValidations(false);
            // history.push({
            //   pathname: `/enquiry/${
            //     res.data.datum && res.data.datum.enquireNo
            //   }`,
            //   state: res.data && res.data.datum,
            // });
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.msg);
          toast.error(
            errorMsg || "There is an issue while calculate the price"
          );
          Promise.reject(error);
        });
    } else {
      // if (travellerDetails.length == 0) {
      //   toast.error("Choose the traveller details");
      //   setEnquireNowButtonDisabled(true);
      //   setTimeout(() => {
      //     setEnquireNowButtonDisabled(false);
      //   }, 3000);
      // }
      setEnquireValidations(true);
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Cab Details | Plan mi trip</title>
        </MetaTags>
      </div>
      <Col
        md={24}
        sm={24}
        lg={24}
        xl={24}
        xxl={24}
        className="mr-[-6px] mt-[-20px]"
      >
        <div
          style={{
            fontFamily: "Poppins",
            // border: "1px solid rgba(200, 203, 206, 0.81)",
          }}
          className="ml-[-6px] w-[101%] relative overflow-hidden shadow-lg cursor-pointer"
        >
          <Image
            //   src={data.imageUrl}
            src={Cabs}
            preview={false}
            height={280}
            // style={{}}
            width={"100%"}
            className="object-center text-start relative cursor-pointer mb-3"
          />
          <div className="absolute inset-0 bg-black bg-opacity-15">
            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              sm={24}
              xs={24}
              className="flex justify-center"
            >
              <Row
                className={
                  media == "md" || media == "sm" || media == "xs"
                    ? "mt-[120px] flex justify-center"
                    : "w-[70%] mt-[120px] flex justify-center"
                }
              >
                <div
                  className={
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "mt-[-8px] w-[100%]"
                      : "mt-[-8px] w-[100%]"
                  }
                >
                  <Row
                    className={
                      media == "sm" || media == "xs"
                        ? "w-[100%] flex flex-col"
                        : "w-[100%] justify-center"
                    }
                  >
                    {cabTabs.map((data, index) => {
                      return (
                        <Col
                          // md={12}
                          // sm={24}
                          // lg={12}
                          // xl={8}
                          // xxl={8}
                          // xs={24}
                          key={index}
                          className="pr-5"
                        >
                          <div
                            className={
                              data.label == "Local Trip" &&
                              data.label === cabTabsList &&
                              (media !== "xs" || media !== "sm")
                                ? "bg-[#eb3e43] w-[100%] pl-6 pr-6 pt-4 pb-4 shadow-md"
                                : data.label == "Local Trip" &&
                                  (media !== "xs" || media !== "sm")
                                ? "bg-[#e5e5e5] w-[100%] pl-6 pr-6 pt-4 pb-4 shadow-md"
                                : data.label === cabTabsList
                                ? "bg-[#eb3e43] w-[100%] p-4 shadow-md"
                                : "bg-[#e5e5e5] w-[100%] p-4 shadow-md"
                            }
                            onClick={() => {
                              setCabTabsList(data.label);
                              if (data.label == "Local Trip") {
                                dispatch(
                                  loadCabDetailsList(
                                    "?type=" + data.value + "&hours=4"
                                  )
                                );
                                setLocalTripTabs("4 Hrs");
                              } else {
                                dispatch(
                                  loadCabDetailsList("?type=" + data.value)
                                );
                              }
                              setOutStationTabs("Out Station - Day Basis");

                              setCabsLoading(true);
                              setTimeout(() => {
                                setCabsLoading(false);
                              }, 500);
                            }}
                          >
                            <div
                              className={
                                data.label === cabTabsList ? "text-[white]" : ""
                              }
                            >
                              <p className="text-[22px] flex justify-center w-[100%]">
                                {data.icon}
                              </p>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                  //   boxShadow: "1px 1px 1px 2px lightgray",
                                }}
                                className="uppercase text-[15px] mt-2 font-semibold text-center"
                              >
                                {data.label}
                              </h1>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Row>
            </Col>
          </div>
        </div>
        <Row
          className={
            media == "sm"
              ? "pr-[5%] pl-[5%] mt-[10px]"
              : media == "xs"
              ? "pl-[30px] mt-[10px]"
              : media == "md"
              ? "pr-[5%] pl-[5%]"
              : media == "lg"
              ? "pr-[7%] pl-[8%]"
              : media == "xxl"
              ? "pr-[9.5%] pl-[10%]"
              : "pr-[4%] pl-[5%]"
          }
        >
          {cabTabsList === "Out Station" ? (
            <div className="w-[100%] mt-6">
              <Row className="w-[100%] justify-center">
                {outStationTrips.map((data, index) => {
                  return (
                    <Col
                      // md={12}
                      // sm={24}
                      // lg={12}
                      // xl={8}
                      // xxl={8}
                      // xs={24}
                      key={index}
                      className="pr-5"
                    >
                      <div
                        className={
                          data.label === outStationTabs
                            ? "bg-[#eb3e43] w-[100%] pl-4 pr-4 pt-2 pb-2 rounded-md cursor-pointer shadow-md"
                            : "bg-[#e5e5e5] w-[100%] pl-4 pr-4 pt-2 pb-2 rounded-md cursor-pointer shadow-md"
                        }
                        onClick={() => {
                          setOutStationTabs(data.label);
                          dispatch(loadCabDetailsList("?type=" + data.value));
                          setCabsLoading(true);
                          setTimeout(() => {
                            setCabsLoading(false);
                          }, 500);
                        }}
                      >
                        <div
                          className={
                            data.label === outStationTabs ? "text-[white]" : ""
                          }
                        >
                          <h1
                            style={{
                              fontFamily: "Poppins",
                              //   boxShadow: "1px 1px 1px 2px lightgray",
                            }}
                            className="capitalize text-[12px] font-semibold text-center"
                          >
                            {data.label}
                          </h1>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
              <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
                <Row>
                  {outStationTabs === "Out Station - Km Basis" ? (
                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className={cabsLoading ? "mt-6" : "mt-6"}
                    >
                      <div className="flex text-[18px] font-semibold p-5 cabs-font text-[#eb3e43] justify-center">
                        OUT STATION ROUND TRIP - KM BASIS
                      </div>
                      <table className="table-cabs table-responsive">
                        <thead>
                          <tr className="table-cabs-head-main">
                            <th className="w-[20%] rounded-tl-md cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              VEHICLES
                            </th>
                            <th className="w-[15%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              MINIMUM CHARGE Kms / DAY
                            </th>
                            <th className="w-[10%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              FARE / KM
                            </th>
                            <th className="w-[10%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              DRIVER / DAY
                            </th>
                            <th className="w-[15%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              TOTAL AMOUNT
                            </th>
                            <th className="w-[10%] rounded-tr-md cabs-font uppercase table-cabs-last-head text-[12px] font-semibold">
                              ACTION
                            </th>
                          </tr>
                        </thead>
                        <tbody className="mb-8">
                          {cabsLoading ? (
                            <tr className="cabs-font w-[100%]">
                              <td colSpan={"100%"} className="p-6 text-center">
                                <Spin
                                  className="text-center"
                                  style={{
                                    color: "#eb3e43",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : cabDetailsTable && cabDetailsTable.length > 0 ? (
                            cabDetailsTable.map((data, index) => {
                              const isLastRow =
                                index === cabDetailsTable.length - 1;
                              return (
                                <tr
                                  // key={index}
                                  className={"w-[100%] table-cabs-row"}
                                >
                                  <td
                                    className={`relative ${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-start text-[13px]`}
                                    onMouseEnter={() => {
                                      setIsHovered(true);
                                      setVehicleDetails(data);
                                    }}
                                    onMouseLeave={() => {
                                      setIsHovered(false);
                                      setVehicleDetails("");
                                    }}
                                  >
                                    <p className=" font-semibold cursor-pointer">
                                      {data.vehicleName !== undefined
                                        ? data.vehicleName
                                        : ""}
                                    </p>
                                    <div className="text-start text-[black] text-[12px] font-medium">
                                      {data.seats !== undefined ? (
                                        <div className="flex">
                                          <h1 className="font-semibold mr-1">
                                            Seating:{" "}
                                          </h1>
                                          <p>{data.seats + "+ 1 Driver"}</p>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <p className=" font-normal cursor-pointer">
                                      {data.vehicleType !== undefined
                                        ? data.vehicleType
                                        : ""}
                                    </p>
                                    {isHovered &&
                                      data._id === vehicleDetails._id && (
                                        <div className="absolute top-full h-[150px] left-2 mt-0 w-52 rounded-xl overflow-hidden border border-gray-300 bg-white shadow-lg z-50">
                                          <Image
                                            src={data.imageUrl}
                                            height={150}
                                            width={"100%"}
                                            alt={data.vehicleName || ""}
                                            preview={false}
                                            className="w-full h-auto object-cover"
                                          />
                                        </div>
                                      )}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-center`}
                                  >
                                    {data.minimumKmPerDay
                                      ? data.minimumKmPerDay + " kms"
                                      : "--"}
                                  </td>

                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black]`}
                                  >
                                    {data.farePerKms
                                      ? "Rs." +
                                        parseFloat(data.farePerKms).toFixed(2)
                                      : "--"}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black]`}
                                  >
                                    {data.driverLabourCost
                                      ? "Rs." +
                                        parseFloat(
                                          data.driverLabourCost
                                        ).toFixed(2)
                                      : "--"}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black] relative cursor-pointer text-[13px]`}
                                    onMouseEnter={() => {
                                      setIsFareHovered(true);
                                      setFareDetails(data);
                                    }}
                                    onMouseLeave={() => {
                                      setIsFareHovered(false);
                                      setFareDetails("");
                                    }}
                                  >
                                    <p className="font-semibold">
                                      {data.amount
                                        ? "Rs." +
                                          parseFloat(data.amount).toFixed(2)
                                        : "--"}
                                    </p>
                                    <p className="font-label text-[#eb3e43]">
                                      Fare Details
                                    </p>
                                    {isFareHovered &&
                                      data._id === fareDetails._id && (
                                        <div className="">
                                          <div className="absolute top-full left-[-40px] mt-0 w-[366px] p-1 bg-white border border-gray-300 rounded-xl shadow-md z-10">
                                            <div className="overflow-hidden rounded-lg">
                                              <table className="w-full text-sm text-gray-800">
                                                <thead>
                                                  <tr className="bg-[#eb3e43] text-white">
                                                    <th
                                                      colSpan={2}
                                                      className="text-center text-[13px] font-semibold py-2 border-b border-gray-300"
                                                    >
                                                      Tariff Details
                                                      (Calculations)
                                                    </th>
                                                  </tr>
                                                </thead>

                                                <tbody className="text-white bg-[#eb3e43]">
                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Total Day(s):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      1
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Total Free Kms (1 Day(s) x{" "}
                                                      {fareDetails?.farePerKms ??
                                                        0}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      {fareDetails?.farePerKms ??
                                                        0}{" "}
                                                      Kms
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Driver Allowance (1 Day(s)
                                                      x Rs.
                                                      {fareDetails?.driverLabourCost ??
                                                        0}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {fareDetails
                                                        ? parseFloat(
                                                            fareDetails.driverLabourCost
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Net Amount (Rs.
                                                      {parseFloat(
                                                        fareDetails?.minimumKmPerDay ||
                                                          0
                                                      ).toFixed(2)}{" "}
                                                      x{" "}
                                                      {parseFloat(
                                                        fareDetails?.farePerKms ||
                                                          0
                                                      ).toFixed(2)}{" "}
                                                      + Rs.
                                                      {parseFloat(
                                                        fareDetails?.driverLabourCost ||
                                                          0
                                                      ).toFixed(2)}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {fareDetails
                                                        ? parseFloat(
                                                            fareDetails.amount
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      GST{" "}
                                                      {
                                                        fareDetails.taxPercentage
                                                      }
                                                      % (Service Tax)
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {parseFloat(
                                                        taxPercentage
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>

                                                  <tr className="bg-[#eb3e43] font-semibold">
                                                    <td className="px-3 py-1 text-[13px] text-left">
                                                      Total Amount:
                                                    </td>
                                                    <td className="px-3 py-1 text-[13px] text-right">
                                                      Rs.
                                                      {parseFloat(
                                                        totalAmount
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </td>

                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-last-data"
                                        : "table-cabs-last-data"
                                    } text-center text-[black]`}
                                  >
                                    <div
                                      className="cursor-pointer hover:bg-[red] text-center uppercase text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                                      style={{
                                        borderRadius: "25px",
                                        // border: "1px",
                                        // padding: "4px 20px",

                                        fontFamily: "Poppins",
                                        background: "#eb3e43",
                                        padding: "2px 20px",
                                        color: "white",
                                        // pointerEvents: bookingButtonDisabled
                                        //   ? "none"
                                        //   : "",
                                        // opacity: bookingButtonDisabled ? "1" : "",
                                        // cursor: bookingButtonDisabled
                                        //   ? "not-allowed"
                                        //   : "pointer",
                                      }}
                                      onClick={() => {
                                        // toast.success(
                                        //   "Thank you for your enquiry about our product"
                                        // );
                                        // buttonClick();
                                        setEnquireModal(true);
                                        setEnquireDetails(data);
                                        setVehicleName(
                                          data.vehicleName !== undefined
                                            ? data.vehicleName
                                            : ""
                                        );
                                        setCustomerMail("");
                                        setCustomerMobile("");
                                        setCustomerName("");
                                        setPickupLocation("");
                                        setAdultData("");
                                        setChildData("");
                                        setTravelDate("");
                                        // addBooking();
                                        // setCabsLoading(true);
                                        // setTimeout(() => {
                                        //   setCabsLoading(false);
                                        // }, 500);
                                      }}
                                    >
                                      <h1
                                        style={{
                                          display: "inline-block",
                                          width: "max-content",
                                        }}
                                      >
                                        {/* {bookingButtonDisabled ? (
                                          <p className="flex justify-center">
                                            <Spin className="ml-1 text-[white]" />
                                            {"Processing..."}
                                          </p>
                                        ) : ( */}
                                        Enquire Now
                                        {/* )} */}
                                      </h1>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr key={0}>
                              <td
                                style={{
                                  borderBottom: "1px solid #8b8b8b",
                                }}
                                colSpan={7}
                                className="text-center"
                              >
                                No Details found
                              </td>
                            </tr>
                          )}
                          {/* {} */}
                        </tbody>
                      </table>
                    </Col>
                  ) : (
                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className={
                        cabsLoading
                          ? "mt-6"
                          : // ? "mt-6 table-main-loading-outstation"
                            "mt-6"
                      }
                    >
                      <div className="flex text-[18px] font-semibold p-5 cabs-font text-[#eb3e43] justify-center">
                        OUT STATION ROUND TRIP - DAY BASIS
                      </div>
                      <table className="table-cabs table-responsive">
                        <thead>
                          <tr className="table-cabs-head-main">
                            <th className="w-[20%] rounded-tl-md cabs-font uppercase table-cabs-starting-head text-[12px] font-semibold">
                              VEHICLES
                            </th>
                            <th className="w-[15%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              RENT / DAY
                            </th>
                            <th className="w-[10%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              FREE KMS / DAY
                            </th>
                            <th className="w-[20%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              FARE / KM (After Free Kms)
                            </th>

                            <th className="w-[10%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              DRIVER / DAY
                            </th>
                            <th className="w-[15%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                              AMOUNT
                            </th>
                            <th className="w-[10%] rounded-tr-md cabs-font uppercase table-cabs-last-head text-[12px] font-semibold">
                              ACTION
                            </th>
                          </tr>
                        </thead>
                        <tbody className="mb-8">
                          {cabsLoading ? (
                            <tr className="cabs-font w-[100%]">
                              <td colSpan={"100%"} className="p-6 text-center">
                                <Spin
                                  className="text-center"
                                  style={{
                                    color: "#eb3e43",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : cabDetailsTable && cabDetailsTable.length > 0 ? (
                            cabDetailsTable.map((data, index) => {
                              const isLastRow =
                                index === cabDetailsTable.length - 1;
                              return (
                                <tr
                                  // key={index}
                                  className={"w-[100%] table-cabs-row"}
                                >
                                  <td
                                    className={`relative ${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-start text-[13px]`}
                                    onMouseEnter={() => {
                                      setIsHovered(true);
                                      setVehicleDetails(data);
                                    }}
                                    onMouseLeave={() => {
                                      setIsHovered(false);
                                      setVehicleDetails("");
                                    }}
                                  >
                                    <p className=" font-semibold cursor-pointer">
                                      {data.vehicleName !== undefined
                                        ? data.vehicleName
                                        : ""}
                                    </p>
                                    <div className="text-start text-[black] text-[12px] font-medium">
                                      {data.seats !== undefined ? (
                                        <div className="flex">
                                          <h1 className="font-semibold mr-1">
                                            Seating:{" "}
                                          </h1>
                                          <p>{data.seats + "+ 1 Driver"}</p>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <p className=" font-normal cursor-pointer">
                                      {data.vehicleType !== undefined
                                        ? data.vehicleType
                                        : ""}
                                    </p>
                                    {isHovered &&
                                      data._id === vehicleDetails._id && (
                                        <div className="absolute top-full h-[150px] left-2 mt-0 w-52 rounded-xl overflow-hidden border border-gray-300 bg-white shadow-lg z-50">
                                          <Image
                                            src={data.imageUrl}
                                            height={150}
                                            width={"100%"}
                                            alt={data.vehicleName || ""}
                                            preview={false}
                                            className="w-full h-auto object-cover"
                                          />
                                        </div>
                                      )}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end`}
                                  >
                                    {data.rentPerDay
                                      ? "Rs." +
                                        parseFloat(data.rentPerDay).toFixed(2)
                                      : "--"}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-center text-[black]`}
                                  >
                                    {data.freeKmsPerDay
                                      ? data.freeKmsPerDay + " kms"
                                      : "--"}
                                  </td>

                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black]`}
                                  >
                                    {data.fareAfterFreeKms
                                      ? "Rs." +
                                        parseFloat(
                                          data.fareAfterFreeKms
                                        ).toFixed(2)
                                      : "--"}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black]`}
                                  >
                                    {data.driverLabourCost
                                      ? "Rs." +
                                        parseFloat(
                                          data.driverLabourCost
                                        ).toFixed(2)
                                      : "--"}
                                  </td>
                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-data"
                                        : "table-cabs-data"
                                    } text-end text-[black] relative cursor-pointer text-[13px]`}
                                    onMouseEnter={() => {
                                      setIsFareHovered(true);
                                      setFareDetails(data);
                                    }}
                                    onMouseLeave={() => {
                                      setIsFareHovered(false);
                                      setFareDetails("");
                                    }}
                                  >
                                    <p className="font-semibold">
                                      {data.amount
                                        ? "Rs." +
                                          parseFloat(data.amount).toFixed(2)
                                        : "--"}
                                    </p>
                                    <p className="font-label text-[#eb3e43]">
                                      Fare Details
                                    </p>
                                    {isFareHovered &&
                                      data._id === fareDetails._id && (
                                        <div className="">
                                          <div className="absolute top-full left-[-40px] mt-0 w-[366px] p-1 bg-white border border-gray-300 rounded-xl shadow-md z-10">
                                            <div className="overflow-hidden rounded-lg">
                                              <table className="w-full text-sm text-gray-800">
                                                <thead>
                                                  <tr className="bg-[#eb3e43]">
                                                    <th
                                                      colSpan={2}
                                                      className="text-center text-white text-[13px] font-semibold py-2 border-b border-gray-300"
                                                    >
                                                      Tariff Details
                                                      (Calculations)
                                                    </th>
                                                  </tr>
                                                </thead>

                                                <tbody className="text-white bg-[#eb3e43]">
                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Total Day(s):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      1
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Total Free Kms (1 Day(s) x
                                                      100 Kms):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      {fareDetails?.freeKmsPerDay ??
                                                        0}{" "}
                                                      Kms
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Total Rent (1 Day(s) x Rs.
                                                      {fareDetails?.rentPerDay ??
                                                        0}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {fareDetails
                                                        ? parseFloat(
                                                            fareDetails.rentPerDay
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Driver Allowance (1 Day(s)
                                                      x Rs.
                                                      {fareDetails?.driverLabourCost ??
                                                        0}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {fareDetails
                                                        ? parseFloat(
                                                            fareDetails.driverLabourCost
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      Net Amount (Rs.
                                                      {parseFloat(
                                                        fareDetails?.rentPerDay ||
                                                          0
                                                      ).toFixed(2)}{" "}
                                                      + Rs.
                                                      {parseFloat(
                                                        fareDetails?.driverLabourCost ||
                                                          0
                                                      ).toFixed(2)}
                                                      ):
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {fareDetails
                                                        ? parseFloat(
                                                            fareDetails.amount
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    </td>
                                                  </tr>

                                                  <tr className="border-b border-gray-200">
                                                    <td className="px-3 py-1 text-[12px] text-left">
                                                      GST{" "}
                                                      {
                                                        fareDetails.taxPercentage
                                                      }
                                                      % (Service Tax)
                                                    </td>
                                                    <td className="px-3 py-1 text-[12px] text-right">
                                                      Rs.
                                                      {parseFloat(
                                                        taxPercentage
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>

                                                  <tr className="bg-[#eb3e43] font-semibold">
                                                    <td className="px-3 py-1 text-[13px] text-left">
                                                      Total Amount:
                                                    </td>
                                                    <td className="px-3 py-1 text-[13px] text-right">
                                                      Rs.
                                                      {parseFloat(
                                                        totalAmount
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </td>

                                  <td
                                    className={`${
                                      isLastRow
                                        ? "table-cabs-last-row-last-data"
                                        : "table-cabs-last-data"
                                    } text-center text-[black]`}
                                  >
                                    <div
                                      className="cursor-pointer hover:bg-[red] text-center uppercase text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                                      style={{
                                        borderRadius: "25px",
                                        // border: "1px",
                                        // padding: "4px 20px",

                                        fontFamily: "Poppins",
                                        background: "#eb3e43",
                                        padding: "2px 20px",
                                        color: "white",
                                        // pointerEvents: bookingButtonDisabled
                                        //   ? "none"
                                        //   : "",
                                        // opacity: bookingButtonDisabled ? "1" : "",
                                        // cursor: bookingButtonDisabled
                                        //   ? "not-allowed"
                                        //   : "pointer",
                                      }}
                                      onClick={() => {
                                        // buttonClick();
                                        setEnquireModal(true);
                                        setEnquireDetails(data);
                                        setVehicleName(
                                          data.vehicleName
                                            ? data.vehicleName
                                            : ""
                                        );
                                        setCustomerMail("");
                                        setCustomerMobile("");
                                        setCustomerName("");
                                        setPickupLocation("");
                                        setAdultData("");
                                        setChildData("");
                                        setTravelDate("");
                                        // addBooking();
                                        // setCabsLoading(true);
                                        // setTimeout(() => {
                                        //   setCabsLoading(false);
                                        // }, 500);
                                      }}
                                    >
                                      <h1
                                        style={{
                                          display: "inline-block",
                                          width: "max-content",
                                        }}
                                      >
                                        {/* {bookingButtonDisabled ? (
                                          <p className="flex justify-center">
                                            <Spin className="ml-1 text-[white]" />
                                            {"Processing..."}
                                          </p>
                                        ) : ( */}
                                        Enquire Now
                                        {/* )} */}
                                      </h1>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr key={0}>
                              <td colSpan={7} className="text-center">
                                No Details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </Col>
                  )}
                </Row>
              </Col>
            </div>
          ) : (
            <div className="w-[100%] mt-6">
              <Row className="w-[100%] justify-center">
                {localTripTabsDetails.map((data, index) => {
                  return (
                    <Col
                      // md={12}
                      // sm={24}
                      // lg={12}
                      // xl={8}
                      // xxl={8}
                      // xs={24}
                      key={index}
                      className="pr-5"
                    >
                      <div
                        className={
                          data.label === localTripTabs
                            ? "bg-[#eb3e43] w-[100%] pl-4 pr-4 pt-2 pb-2 rounded-md cursor-pointer shadow-md"
                            : "bg-[#e5e5e5] w-[100%] pl-4 pr-4 pt-2 pb-2 rounded-md cursor-pointer shadow-md"
                        }
                        onClick={() => {
                          setLocalTripTabs(data.label);
                          dispatch(
                            loadCabDetailsList(
                              `?type=Local&hours=${data.value}`
                            )
                          );
                          setCabsLoading(true);
                          setTimeout(() => {
                            setCabsLoading(false);
                          }, 500);
                        }}
                      >
                        <div
                          className={
                            data.label === localTripTabs
                              ? "text-[white] flex"
                              : " flex"
                          }
                        >
                          <p className="mt-[2px] mr-1">{data.icon}</p>
                          <h1
                            style={{
                              fontFamily: "Poppins",
                              //   boxShadow: "1px 1px 1px 2px lightgray",
                            }}
                            className="capitalize text-[12px] font-semibold text-center"
                          >
                            {data.label}
                          </h1>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
              <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
                <Row>
                  <Col
                    md={24}
                    sm={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    className={cabsLoading ? "mt-6" : "mt-6"}
                  >
                    <div className="flex text-[18px] font-semibold p-5 cabs-font text-[#eb3e43] justify-center">
                      LOCAL TRIP TARIFF
                    </div>
                    <table className="table-cabs table-responsive">
                      <thead>
                        <tr className="table-cabs-head-main">
                          <th className="w-[20%] rounded-tl-md cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            VEHICLES
                          </th>
                          <th className="w-[7%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            HRS
                          </th>
                          <th className="w-[10%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            FREE KMS
                          </th>
                          <th className="w-[18%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            TOTAL AMOUNT
                          </th>
                          <th className="w-[17%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            FARE / HRS (Extra Hrs)
                          </th>
                          <th className="w-[18%] cabs-font uppercase table-cabs-head text-[12px] font-semibold">
                            FARE / KM (After Free Kms)
                          </th>
                          <th className="rounded-tr-md w-[10%] cabs-font uppercase table-cabs-last-head text-[12px] font-semibold">
                            ACTION
                          </th>
                        </tr>
                      </thead>
                      <tbody className="mb-8">
                        {cabsLoading ? (
                          <tr className="cabs-font w-[100%]">
                            <td colSpan={"100%"} className="p-6 text-center">
                              <Spin
                                className="text-center"
                                style={{
                                  color: "#eb3e43",
                                }}
                              />
                            </td>
                          </tr>
                        ) : cabDetailsTable && cabDetailsTable.length > 0 ? (
                          cabDetailsTable.map((data, index) => {
                            const isLastRow =
                              index === cabDetailsTable.length - 1;
                            return (
                              <tr
                                key={index}
                                className={"w-[100%] table-cabs-row"}
                              >
                                <td
                                  className={`relative ${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-start text-[13px]`}
                                  onMouseEnter={() => {
                                    setIsHovered(true);
                                    setVehicleDetails(data);
                                    setFareDetails(data);
                                  }}
                                  onMouseLeave={() => {
                                    setIsHovered(false);
                                    setVehicleDetails("");
                                    setFareDetails("");
                                  }}
                                >
                                  <p className="font-semibold cursor-pointer">
                                    {data.vehicleName !== undefined
                                      ? data.vehicleName
                                      : ""}
                                  </p>
                                  <div className="text-start text-[black] text-[12px] font-medium">
                                    {data.seats !== undefined ? (
                                      <div className="flex">
                                        <h1 className="font-semibold mr-1">
                                          Seating:{" "}
                                        </h1>
                                        <p>{data.seats + "+ 1 Driver"}</p>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <p className="font-normal cursor-pointer">
                                    {data.vehicleType !== undefined
                                      ? data.vehicleType
                                      : ""}
                                  </p>
                                  {isHovered &&
                                    data._id === vehicleDetails._id && (
                                      // <div className="">
                                      <div className="absolute top-full h-[150px] left-2 mt-0 w-52 rounded-xl overflow-hidden border border-gray-300 bg-white shadow-lg z-50">
                                        <Image
                                          src={data.imageUrl}
                                          height={150}
                                          width={"100%"}
                                          alt={data.vehicleName || ""}
                                          preview={false}
                                          className="w-full h-auto object-cover"
                                        />
                                      </div>
                                      // </div>
                                    )}
                                </td>
                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-center text-[13px]`}
                                >
                                  {data.hours ? data.hours : "--"}
                                </td>
                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-center`}
                                >
                                  {data.freeKmsPerDay
                                    ? data.freeKmsPerDay + " kms"
                                    : "--"}
                                </td>
                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-end text-[black] relative cursor-pointer text-[13px]`}
                                  onMouseEnter={() => {
                                    setIsFareHovered(true);
                                    setFareDetails(data);
                                  }}
                                  onMouseLeave={() => {
                                    setIsFareHovered(false);
                                    setFareDetails("");
                                  }}
                                >
                                  <p className="font-semibold">
                                    {data.amount
                                      ? "Rs." +
                                        parseFloat(data.amount).toFixed(2)
                                      : "--"}
                                  </p>
                                  <p className="font-label text-[#eb3e43]">
                                    Fare Details
                                  </p>
                                  {isFareHovered &&
                                    data._id === fareDetails._id && (
                                      <div className="">
                                        <div className="absolute p-1 bg-white top-full left-[-40px] mt-0 w-[366px] rounded-xl shadow-md border border-gray-300 z-10">
                                          <div className="overflow-hidden rounded-lg">
                                            <table className="w-full text-sm text-gray-800">
                                              <thead>
                                                <tr className="bg-[#eb3e43]">
                                                  <th
                                                    colSpan={2}
                                                    className="text-center text-white text-[13px] font-semibold py-2 border-b border-gray-300"
                                                  >
                                                    Tariff Details
                                                    (Calculations)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody className="bg-[#eb3e43]">
                                                <tr className="border-b text-white border-gray-200">
                                                  <td className="px-3 py-1 text-[12px] text-left">
                                                    Fare for (
                                                    {fareDetails?.hours ?? 0}{" "}
                                                    Hrs x{" "}
                                                    {fareDetails?.freeKmsPerDay ??
                                                      0}{" "}
                                                    kms):
                                                  </td>
                                                  <td className="px-3 py-1 text-[12px] text-right">
                                                    Rs.
                                                    {fareDetails
                                                      ? parseFloat(
                                                          fareDetails.amount
                                                        ).toFixed(2)
                                                      : "0.00"}
                                                  </td>
                                                </tr>
                                                <tr className="border-b text-white border-gray-200">
                                                  <td className="px-3 py-1 text-[12px] text-left">
                                                    GST{" "}
                                                    {fareDetails.taxPercentage}%
                                                    (Service Tax)
                                                  </td>
                                                  <td className="px-3 py-1 text-[12px] text-right">
                                                    Rs.
                                                    {parseFloat(
                                                      taxPercentage
                                                    ).toFixed(2)}
                                                  </td>
                                                </tr>
                                                <tr className="bg-[#eb3e43] text-white font-semibold">
                                                  <td className="px-3 py-1 text-[13px] text-left">
                                                    Total Amount:
                                                  </td>
                                                  <td className="px-3 py-1 text-[13px] text-right">
                                                    Rs.
                                                    {parseFloat(
                                                      totalAmount
                                                    ).toFixed(2)}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </td>
                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-end text-[black]`}
                                >
                                  {data.fareAfterFreeHrs
                                    ? "Rs." +
                                      parseFloat(data.fareAfterFreeHrs).toFixed(
                                        2
                                      )
                                    : "--"}
                                </td>
                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-data"
                                      : "table-cabs-data"
                                  } text-end text-[black]`}
                                >
                                  {data.fareAfterFreeKms
                                    ? "Rs." +
                                      parseFloat(data.fareAfterFreeKms).toFixed(
                                        2
                                      )
                                    : "--"}
                                </td>

                                <td
                                  className={`${
                                    isLastRow
                                      ? "table-cabs-last-row-button-data"
                                      : "table-local-last-row-cabs-data"
                                  } text-center text-[black]`}
                                >
                                  <div
                                    className="cursor-pointer hover:bg-[red] text-center uppercase text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                                    style={{
                                      borderRadius: "25px",
                                      // border: "1px",
                                      // padding: "4px 20px",
                                      fontFamily: "Poppins",
                                      background: "#eb3e43",
                                      padding: "2px 20px",
                                      color: "white",
                                      // pointerEvents: bookingButtonDisabled
                                      //   ? "none"
                                      //   : "",
                                      // opacity: bookingButtonDisabled ? "1" : "",
                                      // cursor: bookingButtonDisabled
                                      //   ? "not-allowed"
                                      //   : "pointer",
                                    }}
                                    onClick={() => {
                                      setEnquireModal(true);
                                      setEnquireDetails(data);
                                      setVehicleName(
                                        data.vehicleName !== undefined
                                          ? data.vehicleName
                                          : ""
                                      );
                                      setCustomerMail("");
                                      setCustomerMobile("");
                                      setCustomerName("");
                                      setPickupLocation("");
                                      setAdultData("");
                                      setChildData("");
                                      setTravelDate("");
                                      // addBooking();
                                      // setCabsLoading(true);
                                      // setTimeout(() => {
                                      //   setCabsLoading(false);
                                      // }, 500);
                                    }}
                                  >
                                    <h1
                                      style={{
                                        display: "inline-block",
                                        width: "max-content",
                                      }}
                                    >
                                      {/* {bookingButtonDisabled ? (
                                          <p className="flex justify-center">
                                            <Spin className="ml-1 text-[white]" />
                                            {"Processing..."}
                                          </p>
                                        ) : ( */}
                                      Enquire Now
                                      {/* )} */}
                                    </h1>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr key={0}>
                            <td colSpan={7} className="text-center">
                              No Details found
                            </td>
                          </tr>
                        )}
                        {/* // {} */}
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Col>
            </div>
          )}
        </Row>
        {/* <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        /> */}
        {/* Enquire modal */}
        <Modal
          open={enquireModal}
          // title="Want to Go For A Memorable Holiday?"
          maskClosable={false}
          onClose={() => setEnquireModal(false)}
          closable
          onCancel={() => setEnquireModal(false)}
          okButtonProps={{
            disabled: enquireNowButtonDisabled ? true : false,
          }}
          footer={null}
          className="package-fonts p-3 mt-[-90px]"
          closeIcon
          width={620}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <Row>
              <Col
                md={24}
                sm={24}
                lg={24}
                xl={24}
                xxl={24}
                className="package-fonts text-[20px] font-semibold"
              >
                Enquire Now to get the Cab Details
              </Col>
            </Row>
            <Row>
              <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="mt-3">
                <Typography className="package-fonts mb-[4px]">
                  Package Name
                </Typography>
                <Input
                  name="vehicleName"
                  value={vehicleName}
                  // disabled
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                    paddingLeft: "8px",
                    pointerEvents: "none",
                    opacity: 1,
                  }}
                  className="text-[14px] package-fonts"
                  rootClassName="package-fonts"
                  suffix={<FaCar className="text-[14px] mr-2 text-[#818181]" />}
                />
              </Col>
              <Col
                md={24}
                sm={24}
                lg={24}
                xl={24}
                xxl={24}
                className="flex mt-4"
              >
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[16px] font-semibold"
                >
                  Personal Details
                </h1>
                <p className="mt-3 ml-3 h-[1px] bg-[#ffa096] w-[70%]"></p>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Name
                </Typography>
                <Input
                  name="customerName"
                  value={customerName}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  onChange={(e) => setCustomerName(e.target.value)}
                  placeholder="Your Name"
                  className="text-[14px] package-fonts"
                  suffix={<FaUser className="text-[14px] text-[#818181]" />}
                />
                {enquireValidations === true && customerName === "" ? (
                  <p
                    style={{
                      display: "inline-block",
                    }}
                    className="text-start input-label text-[#ff0000] mt-2 text-[11px]"
                  >
                    The name field is required
                  </p>
                ) : (
                  ""
                )}
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="mt-2 pl-3"
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Mobile
                </Typography>
                <Input
                  name="customerMobile"
                  value={customerMobile}
                  id="main-enquire-input"
                  onChange={validationEnquireChange}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  maxLength={10}
                  placeholder="Your Mobile"
                  className="package-fonts text-[14px]"
                  suffix={<FaMobile className="text-[14px] text-[#818181]" />}
                />
                <div id="error-enquire-panel">
                  {customerMobileValidations == true ? (
                    <p className="input-label text-[11px] text-start text-[#ff0000]">
                      The mobile field is not valid
                    </p>
                  ) : (
                    enquireValidations === true &&
                    customerMobile === "" && (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        {enquireValidations === true && customerMobile === ""
                          ? "The mobile field is required"
                          : ""}
                      </p>
                    )
                  )}
                </div>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className={
                  media == "sm" || media == "xs" ? "mt-2" : "mt-2 pr-2"
                }
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Email ID
                </Typography>
                <Input
                  name="customerMail"
                  value={customerMail}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  onChange={validationEnquireEmailChange}
                  placeholder="Your Email ID"
                  id="main-enquire-email-input"
                  className="package-fonts text-[14px]"
                  suffix={<MailFilled className="text-[14px] text-[#818181]" />}
                />
                <div id="error-enquire-email-panel">
                  {customerEmailValidations == true && (
                    <p className="input-label text-[11px] text-start text-[#ff0000]">
                      The email field is not valid
                    </p>
                  )}
                </div>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className={
                  media == "sm" || media == "xs" ? "mt-2" : "mt-2 pl-2"
                }
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Pickup Date
                </Typography>
                <DatePicker
                  className="w-[100%] h-[40px]"
                  placeholder="Travel Date"
                  bordered={false}
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  value={travelDate}
                  name={"travelDate"}
                  onChange={(date) => {
                    setTravelDate(date);
                  }}
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    borderRadius: "0px",
                    border: "1px solid #cfcfcfe0",
                  }}
                />
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-[4px]">
                  Pickup Location
                </Typography>
                <Input.TextArea
                  name="pickupLocation"
                  value={pickupLocation}
                  style={{
                    height: "60px",
                    fontFamily: "Poppins",
                  }}
                  onChange={(e) => setPickupLocation(e.target.value)}
                  placeholder="Enter your location"
                  className="package-fonts text-[14px]"
                />
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="font-semibold package-fonts text-[14px] mb-[4px]">
                  Travellers
                </Typography>
                <Row className="w-[100%] flex">
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <Input
                      name="adultData"
                      value={adultData}
                      style={{
                        height: "40px",
                        fontFamily: "Poppins",
                      }}
                      onChange={(e) => setAdultData(e.target.value)}
                      placeholder="Adult"
                      className="package-fonts text-[14px]"
                    />
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className={media == "sm" || media == "xs" ? "" : "pl-2"}
                  >
                    <Input
                      name="childData"
                      value={childData}
                      style={{
                        height: "40px",
                        fontFamily: "Poppins",
                      }}
                      onChange={(e) => setChildData(e.target.value)}
                      placeholder="Children"
                      className="package-fonts text-[14px]"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-6">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <div
                  style={{
                    borderRadius: "22px",
                    pointerEvents: enquireNowButtonDisabled ? "none" : "",
                    opacity: enquireNowButtonDisabled ? 1 : "",
                    cursor: enquireNowButtonDisabled
                      ? "not-allowed"
                      : "pointer",
                  }}
                  onClick={() => {
                    enquireNowDetails();
                  }}
                  className={
                    enquireNowButtonDisabled
                      ? "w-[100%] p-1 package-fonts text-center text-[18px] bg-[#eb887e] text-[white]"
                      : "w-[100%] p-1 package-fonts text-center text-[18px] bg-[#eb3e43] text-[white]"
                  }
                >
                  {enquireLoading ? (
                    <Spin />
                  ) : (
                    // <p className="package-fonts">Loading</p>
                    <h1 className="">Enquire Now</h1>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Modal>
      </Col>
    </React.Fragment>
  );
};

CabsDetails.propTypes = {
  location: PropTypes.any,
};

export default withRouter(CabsDetails);
